import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../Parts/Pagination';
import ReportList from './ReportList';
import ReportToolBar from './ReportToolBar';
import * as actionTypes from '../../actions/actionTypes';
import {
  MainBlock,
  BodyBlock,
  TitleWrapper,
  TitleWrapperFlex,
  SearchBoxWrapper,
  Title,
  ListsWrapper,
} from './styles/ReportPageStyles';
import useSelectedReportIdsState from './hooks/useSelectedReportIdsState';
import updateReports from './functions/updateReports';
import CreateEntityButton from '../Parts/CreateEntityButton';
import createReport from '../../actions/api/report/createReport';
import SearchBox from '../Parts/SearchBox';
import useDebounce from '../../hooks/useDebouncedKeyword';
import getReports from '../../actions/api/report/getReports';

/**
 * 報告書一覧画面のページコンポーネント
 * @component
 */
const ReportPage = () => {
  const totalNumber = useSelector(state => state.report.totalNumber);
  const totalPages = useSelector(state => state.report.totalPages);
  const currentPage = useSelector(state => state.report.currentPage);

  const reports = useSelector(state => state.report.reports);
  const currentUserRole = useSelector(state => state.main.innerRole);
  const currentUserInfo = useSelector(state => state.main.userInfo);
  const {
    selectedReportIds,
    toggleReportSelection,
    toggleAllReportsSelection,
    clearAllSelections,
  } = useSelectedReportIdsState(
    reports,
    currentUserRole,
    currentUserInfo,
    currentPage,
  );

  const apiToken = useSelector(state => state.main.apiToken);
  const targetGroupId = useSelector(state => state.main.targetGroupId);
  const dispatch = useDispatch();
  const handleUpdateReportClick = () => {
    updateReports(
      apiToken,
      targetGroupId,
      reports,
      selectedReportIds,
      dispatch,
    );
    clearAllSelections();
  };
  // 報告書作成に必要な情報を取得
  const groupInfo = useSelector(state => state.group.groups);
  const targetGroup = groupInfo.find(group => group.id === targetGroupId);
  const currentTimeISO8601 = new Date().toISOString();

  // 報告書検索関連
  const [keyword, setKeyword] = useState('');
  const debouncedKeyword = useDebounce({ value: keyword });
  useEffect(() => {
    dispatch(
      getReports(
        apiToken,
        { keyword: debouncedKeyword, page: currentPage },
        targetGroupId,
      ),
    );
  }, [apiToken, currentPage, debouncedKeyword, dispatch, targetGroupId]);

  return (
    <MainBlock className="GroupManagementPage">
      <BodyBlock>
        <TitleWrapper>
          <TitleWrapperFlex>
            <Title>
              <FormattedMessage id="report.header.title" />
            </Title>
            {/* 報告書検索ボックス */}
            <SearchBoxWrapper>
              <SearchBox
                width="300px"
                placeholder="報告書No、報告書名、作成者で検索"
                onChange={e => setKeyword(e.target.value)}
              />
            </SearchBoxWrapper>
          </TitleWrapperFlex>
          {/* 報告書作成ボタン */}
          <CreateEntityButton
            onCreate={() =>
              dispatch(
                createReport(
                  apiToken,
                  targetGroupId,
                  targetGroup?.name,
                  currentTimeISO8601,
                ),
              )
            }
            labelId="report.header.button.create"
          />
        </TitleWrapper>
        <ReportToolBar
          selectedReportIds={selectedReportIds}
          onDataDeleteClick={handleUpdateReportClick}
          currentUserRole={currentUserRole}
        />
        <ListsWrapper userRole={currentUserRole}>
          <ReportList
            reports={reports}
            onSelect={toggleReportSelection}
            onSelectAll={toggleAllReportsSelection}
            currentUserRole={currentUserRole}
            currentPage={currentPage}
          />
        </ListsWrapper>
        <Pagination
          totalNumber={totalNumber}
          totalPages={totalPages}
          currentPage={currentPage}
          onSelect={page =>
            dispatch({ type: actionTypes.SELECT_REPORTS_PAGE, page })
          }
        />
      </BodyBlock>
    </MainBlock>
  );
};

export default ReportPage;
